import { computed, getCurrentInstance } from "@vue/composition-api";
import { differenceInMinutes } from "date-fns";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { MUTATION_TYPES } from "@/store/const";
import providers from "@/lib/api";

export default function usePaymentPackages(types: PaymentPackageEnum[]) {
  const vm = getCurrentInstance();

  const paymentPackages = computed<PaymentPackage[]>(() => {
    if (!vm) return [];
    return types.reduce(
      (acc: PaymentPackage[], type) => acc.concat(vm.$store.state.paymentPackages[type]?.items ?? []),
      []
    );
  });

  const getPaymentPackages = async () => {
    if (types.length === 0) return;
    const typesToUpdate = types.filter(type => {
      const timeStamp = vm?.$store.state.paymentPackages[type]?.timestamp ?? "";
      if (!timeStamp) return true;
      return differenceInMinutes(new Date(), new Date(timeStamp)) >= 5;
    });
    if (typesToUpdate.length === 0) return;
    const packages = await providers.PaymentPackageProvider.findAll({ type: typesToUpdate });
    typesToUpdate.forEach(type => {
      vm?.$store.commit(MUTATION_TYPES.SET_PAYMENT_PACKAGES, {
        type,
        packages: typesToUpdate.length === 1 ? packages : packages.filter(p => p.type === type),
      });
    });
  };

  return { paymentPackages, getPaymentPackages };
}
